import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { inject, NgModule, provideAppInitializer } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { OAuthModule, OAuthStorage } from 'angular-oauth2-oidc';

import { getLocalStorage } from '../utils/getLocalStorage';
import { AuthInterceptor } from './auth.interceptor';
import { AuthService } from './auth.service';
import { LoginComponent } from './login.component';
import { HlmButtonDirective } from '@spartan-ng/ui-button-helm';

// We need a factory, since localStorage is not available during AOT build time.
export function storageFactory(): OAuthStorage {
  return getLocalStorage();
}

@NgModule({
  declarations: [LoginComponent],
  imports: [
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    ReactiveFormsModule,
    TranslateModule,
    OAuthModule.forRoot(),
    RouterModule.forChild([
      // Login route, will redirect to identity provider
      { path: 'login', component: LoginComponent, title: `Login | ${document.title}` },
    ]),
    HlmButtonDirective,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: OAuthStorage, useFactory: storageFactory },
    provideAppInitializer(() => {
      const initializerFn = (
        (auth: AuthService) => () =>
          auth.initAuth()
      )(inject(AuthService));
      return initializerFn();
    }),
  ],
  exports: [LoginComponent],
})
export class AuthModule {}

